// extracted by mini-css-extract-plugin
export default {"profile":"SuccessUpload_profile--gcp","button":"SuccessUpload_button--fpT","successInfo":"SuccessUpload_successInfo--kQ1","preLinkText":"SuccessUpload_preLinkText--y4i"};